import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M19.717 12.451h-3.181v-1.59h3.18zm0 .909h-3.181v1.59h3.18zm0-7.498h-3.181v1.59h3.18zm0 2.5h-3.181v1.59h3.18zm0 7.497h-3.181v1.59h3.18zm2.197 3.135c-.091.473-.66.484-1.039.5H13.81v2.045h-1.411L2 19.72V3.82L12.46 2h1.35v1.81h6.822c.384.017.807-.01 1.14.219.235.336.212.763.228 1.15l-.01 11.827c-.01.661.062 1.336-.076 1.988M10.33 15.43c-.627-1.273-1.265-2.536-1.89-3.808a472 472 0 0 0 1.833-3.724q-.774.038-1.544.093c-.384.934-.832 1.843-1.132 2.808-.28-.91-.65-1.788-.988-2.676q-.75.042-1.5.086c.527 1.164 1.089 2.31 1.6 3.48-.602 1.137-1.166 2.289-1.75 3.432.498.02.995.04 1.493.047.354-.904.795-1.774 1.104-2.697.277.991.748 1.907 1.134 2.854q.82.058 1.64.105M20.916 4.89H13.81v.972h1.817v1.59H13.81v.91h1.817v1.59H13.81v.909h1.817v1.59H13.81v.909h1.817v1.59H13.81v.909h1.817v1.59H13.81v1.05h7.106z"
    }, null, -1)
  ])))
}
export default { render: render }